import BroadComponentType from 'owa-bundling/lib/types/BroadComponentType';
import React from 'react';
import { ErrorMap } from './ErrorMap';
import { ErrorScreenProps } from './ErrorScreen.types';
import { LazyModule } from 'owa-bundling-light';
import { TraceErrorObject } from 'owa-trace';

export const enum ErrorHandlerConfigType {
    simple,
    suspense,
    owaLazy,
}

export type SimpleComponent<TProps> = React.ComponentType<TProps>;

export type SuspenseComponent<TProps> =
    | React.LazyExoticComponent<(props: TProps) => JSX.Element>
    | React.LazyExoticComponent<React.ComponentType<TProps>>;

export type WrappedComponentType<TProps> =
    | SimpleComponent<TProps>
    | SuspenseComponent<TProps>
    | null;

interface BaseErrorHandlerConfig {
    errorScreen?: ErrorScreenProps;
    unhandledExceptionHandler?: (error: TraceErrorObject) => void;
}
export interface SimpleWrapperConfig extends BaseErrorHandlerConfig {
    configType: ErrorHandlerConfigType.simple;
    errorSource?: ErrorMap;
}
export interface SuspenseLoadConfig extends BaseErrorHandlerConfig {
    configType: ErrorHandlerConfigType.suspense;
    SuspenseFallBackComponent: React.ComponentType;
}

export interface LazyLoadConfig<TProps, TModule, TInnerRef, TPlaceHolderRef>
    extends BaseErrorHandlerConfig {
    configType: ErrorHandlerConfigType.owaLazy;
    lazyModule: LazyModule<TModule>;
    componentGetter: ComponentGetter<TModule, TProps, TInnerRef>;
    placeholder?: BroadComponentType<TProps, TPlaceHolderRef>;
    importErrorHandler?: (reason: any) => void;
}

export type ComponentGetter<TModule, TProps, TInnerRef> = (
    module: TModule
) => BroadComponentType<TProps, TInnerRef>;

export type ErrorConfig<TProps, TModule, TInnerRef, TPlaceHolderRef> =
    | SimpleWrapperConfig
    | SuspenseLoadConfig
    | LazyLoadConfig<TProps, TModule, TInnerRef, TPlaceHolderRef>;
